import { useMemo } from 'react';

import { MESSAGES } from '../../../../constants';
import { IButtonVerticalItem } from '../../../common/messageCreators';
import { renderModel } from '../../../util/renderModel';

/**
 * if the CTAs have "Only 2 options that have 3 characters or less"
 * we show the default buttons
 */
export const useCanUseDefaultButtons = (type: string, items: IButtonVerticalItem[]): boolean => {
  return useMemo(() => {
    const isDefault = type === MESSAGES.BUTTONS;

    if (isDefault && renderModel.isMobile()) {
      return items.length < 3 && items.every((i) => i.label.length < 4);
    }

    return isDefault;
  }, [type, items]);
};
